import { InterpolationWithTheme } from "@emotion/core";



export const rosterStyles: { [key: string]: InterpolationWithTheme<any> } = {
    rosterContainer: {
        paddingTop: "50px",
        display: "flex",
        flexDirection: "column"
    },
    rosterCardContainer: {
        borderRadius: "10px",
        boxShadow: "0px 0px 4px 0px rgba(157, 157, 157, 0.5)",
        flex: 1,
        background: "#ffffff",
        minHeight: "unset",
        minWidth: "calc(100% - 20px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    },
    rosterCardLeft: {
        flex: 1,
        textAlign: "center",
        padding: "15px",
        background: "#ecf5ff",
        color: "#000000"
    },
    rosterCardMiddle: {
        flex: 3,
        textAlign: "center",
        color: "#666666",
        fontSize: "14px"
    },
    rosterTextMedium: {
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "12px",
        fontWeight: 500,
        textTransform: "uppercase"
    },
    rosterTextBold: {
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "22px",
        fontWeight: 5000
    },
    rosterModalBody: {
        width: "100vw"
    },
    rosterModalTimeSelectors: {
        display: "flex",
        flexDirection: "row"
    },
    rosterModalFooter: {
        float: "unset",
        display: "flex",
        justifyContent: "space-between"
    },
    rosterCloseBtn: {
        padding: "5px 50px !important"
    },
    workingHoursView: {
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid #979797",
        margin: "15px"
    },
    copyBtn: {
        margin: "unset",
        padding: "unset",
        background: "#ffffff",
        color: "rgb(255, 49, 109)",
        cursor: "pointer"
    },
    editBtn: {
        display: "flex",
        justifyContent: "center",
        color: "#e53973"
    },
    editImg: {
        height: "15px",
        marginRight: "5px"
    },
    copyIcon: {
        marginRight: "5px"
    },
    daysList: {
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap"
    },
    copyTable: {
        width: "100% !important"
    },
    rosterBannerContainer: {
        width: "calc(100% - 20px)",
        margin: "10px auto",
        display: "flex",
        padding: " 15px 10px 10px 10px",
        borderRadius: "10px",
        border: "1px solid rgb(234, 234, 234)"
    },
    bannerClock: {
        height: "50px",
        marginRight: "10px"
    },
    bannerHeader: {
        margin: "unset",
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: "20px",
        fontWeight: "bold"
    },
    bannerText: {
        color: "rgba(0, 0, 0, 0.5)",
        fontSize: "14px",
    },
    bannerCtaContainer: {
        flex: 1,
        textAlign: "right",
        alignSelf: "center",
    },
    bannerCta: {
        background: "linear-gradient(-225deg, rgb(247, 69, 48) 0%, rgb(255, 46, 115) 100%)",
        borderRadius: "31px",
        boxShadow: "0px 3px 16px 0px rgba(247, 123, 155, 0.71)",
        border: "none",
        padding: "7px 30px",
        color: "#ffffff",
        textTransform: "uppercase",
        fontFamily: "BrandonTextWeb-Bold",
        fontSize: "14px"
    },
    timeSelectionWrapper: {
        display: "flex",
        flexDirection: "row",
        columnGap: "21px",
        marginRight: "60px",
        marginBottom: "10px"
    },
    defaultWorkingHoursButton: {
        background: "rgb(255, 255, 255)",
        borderRadius: "20px",
        border: "1px solid rgb(255, 49, 109)",
        padding: "10px 25px",
        color: "rgb(255, 49, 109)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "14px",
        textDecoration: "none"
    },
    defaultWorkingHoursAlign: {
        marginTop: "7px",
        marginBottom: "13px"
    },
    rosterModalMobileTimeSelectors: {
        display: "flex",
        flexDirection: "column"
    },
    errorMsg: {
        background: "#ffdcdc",
        borderRadius: "4px",
        color: "rgb(255, 0, 0)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "12px",
        fontWeight: 500,
        padding: "5px",
        display: "inline-block"
    },
    warnMsg: {
        background: "#ffebde",
        borderRadius: "4px",
        color: "#ff6600",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "12px",
        fontWeight: 500,
        padding: "5px",
        display: "inline-block"
    },
    topNav: {
        padding: "0px 35px !important"
    },
    rightCTAContainer: {
        display: "flex",
        color: "rgb(255, 49, 109)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: "14px",
        textDecoration: "none"
    },
    playIcon: {
        marginRight: "5px"
    },
    playContainer: {
        margin: "12px 15px 0px 0px",
        cursor: "pointer"
    }
}
